import { render, staticRenderFns } from "./claim-demage.vue?vue&type=template&id=184f2b2a&scoped=true&"
import script from "./claim-demage.vue?vue&type=script&lang=js&"
export * from "./claim-demage.vue?vue&type=script&lang=js&"
import style0 from "./claim-demage.vue?vue&type=style&index=0&id=184f2b2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f2b2a",
  null
  
)

export default component.exports